import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordForm } from "@/auth/components/ForgotPasswordForm";
import logo from "@/assets/EcoPROFIT_Wordmark.png";
import loginImage from "@/assets/login-image.png";

export const Route = createFileRoute("/forgot-password")({
  component: ForgotPassword,
});

function ForgotPassword() {
  return (
    <div className="flex h-full w-full grow flex-row">
      <div className="hidden flex-1 overflow-hidden sm:block">
        <img src={loginImage} alt="login" className="h-full w-full object-cover object-center" />
      </div>
      <section className="flex flex-1 items-center justify-center sm:items-start">
        <div className="flex w-full max-w-[348px] flex-col items-center gap-8 px-4 pb-0 pt-10 sm:px-0 sm:pt-40">
          <img src={logo} alt="EcoPROFIT logo" className="h-[48px] w-[202px]" />
          <ForgotPasswordForm />
        </div>
      </section>
    </div>
  );
}
